import { useQuery } from "react-query";
import { apiGetEmployeeOccupiedSchedule } from "../../../../../api/employee/apiGetEmployeeOccupiedSchedule";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";

type QueryFnType = typeof apiGetEmployeeOccupiedSchedule;

type TUseEmployeeOccupiedScheduleOptions = {
  candidateId: string | undefined;
  config?: QueryConfig<QueryFnType>;
};

export const useEmployeeOccupiedSchedule = ({
  candidateId,
  config,
}: TUseEmployeeOccupiedScheduleOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["employeeOccupiedSchedule", candidateId],
    queryFn: () => apiGetEmployeeOccupiedSchedule(candidateId as string),
    enabled: !!candidateId && (config?.enabled ?? true),
  });
};
